function _(e,a,r){var t=e(304);r.CanvasTexture=t.CanvasTexture;var u=e(306);r.ImageURLTexture=u.ImageURLTexture;var x=e(305);r.Texture=x.Texture}
//# sourceMappingURL=index.min.js.map